/**
 * Handle initiation
 */
export const handleShopifyLoad = () => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // @ts-ignore
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }
};
